let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1wKWZ")).then(() => parcelRequire('ejcQh'));